import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import DefaultCard from 'components/mycomponents/DefaultCard';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { getColor, rgbaColor } from 'helpers/utils';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { toast } from 'react-toastify';
import axios from 'api/axios';

import ModalAlert from 'components/mycomponents/ModalAlert';
import { dateFormatFull } from "../../../utils/FormatDate";

import {
  GridComponent,
  TooltipComponent,
  TitleComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import BasicECharts from 'components/common/BasicEChart';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  CanvasRenderer
]);

const getOptions = (data, date) => ({
  tooltip: {
    trigger: 'axis',
    formatter: '<strong>{b0}</strong> : {c0}'
  },
  xAxis: {
    data: date
  },
  series: [
    {
      type: 'line',
      data,
      smooth: true,
      lineStyle: {
        width: 3
      },

      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: rgbaColor(getColor('primary'), 0.25)
            },
            {
              offset: 1,
              color: rgbaColor(getColor('primary'), 0)
            }
          ]
        }
      }
    }
  ],
  grid: {
    bottom: '2%',
    top: '2%',
    right: '10px',
    left: '10px'
  }
});


const Dashboard = () => {
    // Decalre State Variable
    const  [dataTarget, setDataTarget] = useState({decTarget: 0, decRealization: 0});
    const  [dataIncomeToday, setDataIncomeToday] = useState(0);
    const  [dataLocation, setDataLocation] = useState(null);
    const [loadingTarget, setLoadingTarget] = useState(false);
    const [showAlert, setShowAlert] = useState({show: false, message: '', type: '', confirmButton: false});

    // Declare Constant Variable
    const navigate = useNavigate();
    const DATA_URL = '/dashboard';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    const HEADER_AUTHORIZATION = {
        headers: {
          'Authorization': `Bearer ${TOKEN_APP}`
        }
    };
    const DATENOW = new Date();

    // function get data
    const getData = async () => {
        setLoadingTarget(true);
        try {
            const response = await axios.get(`${DATA_URL}/parking/target`, HEADER_AUTHORIZATION);
            const responseResult = response?.data;
            const responseData = responseResult?.data;
            setDataTarget({
                ...dataTarget, decTarget: responseData.dectarget, decRealization: responseData.decrealization
            })
            
            setLoadingTarget(false);
            
        } catch (err) {
            setLoadingTarget(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer. as', type: 'error'} })
            }
        }
    }

    const getDataLocation = async () => {
        setLoadingTarget(true);
        try {
            const response = await axios.get(`${DATA_URL}/parking/location`, HEADER_AUTHORIZATION);
            const responseResult = response?.data;
            const responseData = responseResult?.data;
            setDataLocation(responseData);

            if (responseData) {
                let incomeToday = 0;
                for (let index = 0; index < responseData.length; index++) {
                    incomeToday = parseFloat(incomeToday) + parseFloat(responseData[index].decincome)
                }
                setDataIncomeToday(incomeToday)
            }
            
            setLoadingTarget(false);
            
        } catch (err) {
            setLoadingTarget(false);
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    // Get Data On Load
    useEffect(() => {
        getData();
        getDataLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Row className="g-3 mb-3">
                <Col sm={12} xxl={12}>
                    <DefaultCard>
                        <DefaultCard.Header title={'DASHBOARD  PARKIR'} loadingTarget={loadingTarget} />
                        <DefaultCard.Body>
                            <Row className="g-3 mb-3">
                                <Col xs={12} md={4} className={'border-200 border-end pb-4'}>
                                    <Flex
                                        justifyContent="center"
                                        alignItems="between"
                                    >
                                        <div>
                                            <h5 className="fw-normal text-700 mb-1 lh-1">Target Pendatapatan {DATENOW.getFullYear()}</h5>
                                            <h3 className="fw-normal text-700 mb-1 lh-1">{parseFloat(dataTarget.decTarget).toLocaleString('ID')}</h3>
                                        </div>
                                    </Flex>
                                </Col>
                                <Col xs={12} md={4} className={'border-200 border-end pb-4'}>
                                    <Flex
                                        justifyContent="center"
                                        alignItems="between"
                                    >
                                        <div>
                                            <h5 className="fw-normal text-700 mb-1 lh-1">Realisasi Pendapatan</h5>
                                            <h3 className="fw-normal text-700 mb-1 lh-1">{parseFloat(dataTarget.decRealization).toLocaleString('ID')}</h3>
                                        </div>
                                    </Flex>
                                </Col>
                                <Col xs={12} md={4} className={'border-200 border-end pb-4'}>
                                    <Flex
                                        justifyContent="center"
                                        alignItems="between"
                                    >
                                        <div>
                                            <h5 className="fw-normal text-700 mb-1 lh-1">Pendapatan Hari Ini</h5>
                                            <h3 className="fw-normal text-700 mb-1 lh-1">{parseFloat(dataIncomeToday).toLocaleString('ID')}</h3>
                                        </div>
                                    </Flex>
                                </Col>
                            </Row>
                        </DefaultCard.Body>
                    </DefaultCard>
                </Col>
                
                <Col sm={12} xxl={12}>
                    <DefaultCard>
                        <DefaultCard.Body>

                            <h6 className="pb-1 border-bottom text-700 pb-2 mb-4">Pendapatan Harian Lokasi Parkir : {dateFormatFull()}</h6>
                            <Row className="g-3 mb-3">
                                {
                                    dataLocation ? dataLocation.map((val, idx) => {
                                        return (
                                            <Col xs={12} md={6} lg={3} className={'border-200 pb-4'} key={idx}>
                                                <Flex
                                                    justifyContent="center"
                                                    alignItems="between"
                                                    className="mb-3"
                                                >
                                                    <div>
                                                        <h6 className="fw-normal text-700 mb-1 lh-1">{val.vcname}</h6>
                                                        <h4 className="fw-normal text-700 mb-1 lh-1">{parseFloat(val.decincome).toLocaleString('ID')}</h4>
                                                        {/* <Badge pill bg="200" className="text-primary fs--2">
                                                            <FontAwesomeIcon icon="caret-up" className="me-1" />
                                                            13.6%
                                                        </Badge> */}
                                                    </div>
                                                    <div className="ps-0">
                                                        <BasicECharts
                                                            echarts={echarts}
                                                            options={getOptions(val.income, val.income_data)}
                                                            style={{ width: '8.5rem', height: 90 }}
                                                        />
                                                    </div>
                                                </Flex>
                                            </Col>
                                        );
                                    }) : ''
                                }
                            </Row>
                        </DefaultCard.Body>
                    </DefaultCard>
                </Col>
            </Row>

            <ModalAlert 
                type={showAlert.type}
                show={showAlert.show}
                message={showAlert.message}
                onHide={() => setShowAlert(prevState => { return {...prevState, show: false} })}
                confirmButton={showAlert.confirmButton}
            />
        </>
    )
}

Dashboard.propTypes = {}

export default Dashboard;